import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import styled from 'styled-components';

type Props = {
    resendEmail: Function;
};

const ForgotPasswordConfirm = ({ resendEmail }: Props) => {
    return (
        <ContentWrapper>
            <BodyPrimary className="mb-md">
                <FormattedMessage id="forgotPasswordConfirmation.text" />
            </BodyPrimary>
            <BodyPrimary>
                <FormattedMessage
                    id="forgotPasswordConfirmation.help"
                    values={{
                        link: (
                            <Link
                                key="forgot-password-confirm-link"
                                onClick={resendEmail}
                            >
                                <FormattedMessage id="forgotPasswordConfirmation.helpLink" />
                            </Link>
                        ),
                    }}
                />
            </BodyPrimary>
        </ContentWrapper>
    );
};

export default ForgotPasswordConfirm;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
`;
